import React, { Component } from 'react'
import {Rectangle, Circle, Ellipse, Polyline, CornerBox, Triangle} from 'react-shapes';
import Typography from '@material-ui/core/Typography';


class ResidualMark extends Component {
	render() {

		let radius = 15
		let MarkDistance = 10
		let fontSize = '20px'

		// offset to place the token in (1,1)
		const topOffset = 4 * 65 + 4 * 2 + 46
		const leftOffset = 46

		// calculate how many px should the token to move to desired position
		let MoveY = (parseInt(this.props.PositionY,10) - 1) * (this.props.side + 2)
		let MoveX = (parseInt(this.props.PositionX,10) - 1) * (this.props.side + 2)

		// calculate padding
		MoveY = MoveY - this.props.paddingY * MarkDistance * 2
		MoveX = MoveX + this.props.paddingX * MarkDistance * 2

		let positionX = leftOffset + MoveX
		let positionY = topOffset - MoveY

		return (
        	<div style={{position:'absolute', top: positionY+'px', left: positionX+'px'}}>
        	    <Typography style={{position: 'absolute', fontSize: fontSize, left: '2px', top:'1px'}} >{(this.props.name).substring(0, 2)}</Typography>
        	    <Circle r={radius} fill={{color:'#ffffff'}} stroke={{color:'#000000'}} strokeWidth={1} />
        	</div>
        )
    }
}
export default ResidualMark;


// WEBPACK FOOTER //
// ./src/components/SharedComponents/ResidualMark.js